class CartAjax {
  constructor() {
    this.init();
    this.observePageChanges();
  }

  init() {
    // Inicializar variant selectors
    this.initVariantSelectors();

    document.addEventListener('submit', (e) => {
      if (e.target.matches('[data-product-form]')) {
        e.preventDefault();
        this.addToCart(e.target);
      }
    });

    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-qty-change]')) {
        const change = parseInt(e.target.dataset.qtyChange);
        const item = e.target.closest('[data-cart-item]');
        const input = item.querySelector('[data-qty-input]');
        const newQty = parseInt(input.value) + change;
        if (newQty > 0) {
          this.updateQuantity(item.dataset.lineKey, newQty);
        }
      }

      if (e.target.matches('[data-remove-item]')) {
        const item = e.target.closest('[data-cart-item]');
        this.updateQuantity(item.dataset.lineKey, 0);
      }
    });

    document.addEventListener('change', (e) => {
      if (e.target.matches('[data-qty-input]')) {
        const item = e.target.closest('[data-cart-item]');
        const newQty = parseInt(e.target.value);
        if (newQty >= 0) {
          this.updateQuantity(item.dataset.lineKey, newQty);
        }
      }
    });

    document.addEventListener('change', (e) => {
      if (e.target.matches('[data-cart-note]')) {
        this.updateNote(e.target.value);
      }
    });
  }

  observePageChanges() {
    // Watch DOM changes to detect SPA navigation
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.querySelector('[data-product-form]')) {
              this.initVariantSelectors();
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also listen for common navigation events
    window.addEventListener('popstate', () => {
      setTimeout(() => this.initVariantSelectors(), 100);
    });

    // Si usas Shopify sections rendering
    document.addEventListener('shopify:section:load', () => {
      this.initVariantSelectors();
    });
  }

  initVariantSelectors() {
    document.querySelectorAll('[data-product-form]').forEach(form => {
      // Avoid initializing the same form twice
      if (form.dataset.cartAjaxInitialized === 'true') {
        return;
      }
      form.dataset.cartAjaxInitialized = 'true';

      const option1Select = form.querySelector('[data-option-select="1"]');
      const option2Select = form.querySelector('[data-option-select="2"]');
      const hiddenVariantInput = form.querySelector('[name="id"]');
      const singleSelect = form.querySelector('.select-variant:not([data-option-select])');
      
      // Price elements
      const priceElement = form.closest('.product-info')?.querySelector('[data-price]') || 
                           document.querySelector('[data-price]');
      const comparePriceElement = form.closest('.product-info')?.querySelector('[data-compare-price]') || 
                                  document.querySelector('[data-compare-price]');
      const saleBadge = form.closest('.product-info')?.querySelector('.product-badge-sale') || 
                        document.querySelector('.product-badge-sale');

      // Products with 2 options (sets)
      if (option1Select && option2Select && hiddenVariantInput) {
        const updateVariant = () => {
          const option1Value = option1Select.value;
          const option2Value = option2Select.value;
          
          
          const selectedOption = Array.from(hiddenVariantInput.querySelectorAll('option')).find(opt => {
            const option1Data = opt.dataset.option1;
            const option2Data = opt.dataset.option2;
            
            return option1Data === option1Value && option2Data === option2Value;
          });

          if (selectedOption) {
            hiddenVariantInput.value = selectedOption.value;
            
            // Update price
            this.updatePrice(selectedOption, priceElement, comparePriceElement, saleBadge);
            
            // Update stock info
            const stockInfo = form.querySelector('[data-stock-info]');
            if (stockInfo) {
              const stock = parseInt(selectedOption.dataset.stock, 10);
              this.updateStockDisplay(stockInfo, stock, !selectedOption.disabled);
            }

            // Update button
            const addButton = form.querySelector('.add-to-cart');
            if (addButton) {
              const isAvailable = !selectedOption.disabled;
              addButton.disabled = !isAvailable;
              const btnText = addButton.querySelector('.btn-text');
              if (btnText) {
                btnText.textContent = isAvailable ? 'ADD TO CART' : 'SOLD OUT';
              }
            }
          } else {
          }
        };

        option1Select.addEventListener('change', updateVariant);
        option2Select.addEventListener('change', updateVariant);
        
        // Select first in-stock variant on load
        this.selectFirstAvailableVariant(hiddenVariantInput, option1Select, option2Select);
        updateVariant();
      }

      // Standard products (1 option)
      if (singleSelect) {
        const updateStockForSingle = () => {
          const stockInfo = form.querySelector('[data-stock-info]');
          const selectedOption = singleSelect.options[singleSelect.selectedIndex];
          
          if (stockInfo) {
            const stock = parseInt(selectedOption.dataset.stock, 10);
            this.updateStockDisplay(stockInfo, stock, !selectedOption.disabled);
          }
          
          // Update price
          this.updatePrice(selectedOption, priceElement, comparePriceElement, saleBadge);
        };

        singleSelect.addEventListener('change', updateStockForSingle);
        
        // Select first in-stock variant on load
        this.selectFirstAvailableVariantSingle(singleSelect);
        updateStockForSingle();
      }
    });
  }

  // Select first in-stock variant (2-option products)
  selectFirstAvailableVariant(hiddenVariantInput, option1Select, option2Select) {
    const options = Array.from(hiddenVariantInput.querySelectorAll('option'));
    const firstAvailable = options.find(opt => !opt.disabled && parseInt(opt.dataset.stock) > 0);
    
    if (firstAvailable) {
      hiddenVariantInput.value = firstAvailable.value;
      option1Select.value = firstAvailable.dataset.option1;
      option2Select.value = firstAvailable.dataset.option2;
    }
  }

  // Select first in-stock variant (1-option products)
  selectFirstAvailableVariantSingle(singleSelect) {
    const options = Array.from(singleSelect.options);
    const firstAvailable = options.find(opt => !opt.disabled && parseInt(opt.dataset.stock) > 0);
    
    if (firstAvailable) {
      singleSelect.value = firstAvailable.value;
    }
  }

  // Update price dynamically
  updatePrice(variantOption, priceElement, comparePriceElement, saleBadge) {
    if (!priceElement || !variantOption.dataset.price) return;
    
    const price = parseInt(variantOption.dataset.price);
    const comparePrice = parseInt(variantOption.dataset.comparePrice);
    
    priceElement.textContent = this.formatMoney(price);
    
    // Handle compare price and sale badge
    if (comparePrice && comparePrice > price) {
      if (comparePriceElement) {
        comparePriceElement.textContent = this.formatMoney(comparePrice);
        comparePriceElement.style.display = '';
      }
      if (saleBadge) saleBadge.style.display = '';
      priceElement.className = 'product-price-sale';
    } else {
      if (comparePriceElement) comparePriceElement.style.display = 'none';
      if (saleBadge) saleBadge.style.display = 'none';
      priceElement.className = 'product-price';
    }
  }

  // Currency-aware money formatter — uses Shopify.currency.active (set by
  // Shopify on every storefront page) so the symbol matches the customer's
  // selected currency. Variant data-price cents are already in the active
  // currency thanks to Shopify Markets, so we just need the right symbol.
  formatMoney(cents) {
    try {
      const code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  updateStockDisplay(stockInfo, stock, available) {
    if (!stockInfo) return;

    /* Items set to keep selling (gift cards, made-to-order beanies) can sit at
       0 or below and still be bought: say nothing rather than "Out of stock"
       next to a working ADD TO CART. */
    if (available && !(stock > 0)) {
      stockInfo.textContent = '';
      stockInfo.className = 'product-stock-info';
      return;
    }
    if (stock <= 0) {
      stockInfo.textContent = 'Out of stock';
      stockInfo.className = 'product-stock-info out-of-stock';
    } else if (stock <= 5) {
      stockInfo.textContent = `Only ${stock} left in stock`;
      stockInfo.className = 'product-stock-info low-stock';
    } else {
      stockInfo.textContent = 'In stock, ready to ship';
      stockInfo.className = 'product-stock-info in-stock';
    }
  }

  async addToCart(form) {
    const formData = new FormData(form);
    const variantId = formData.get('id');
    const quantity = formData.get('quantity') || 1;


    const button = form.querySelector('.add-to-cart');
    const text = button?.querySelector('.btn-text');
    const loader = button?.querySelector('.btn-loader');

    if (button) button.disabled = true;
    if (text) text.hidden = true;
    if (loader) loader.hidden = false;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: parseInt(quantity)
        })
      });

      if (response.ok) {
        await this.refreshCart();
        this.openCart();
      } else {
        const error = await response.json();
        this.showNotification(error.description || 'Error adding product', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      this.showNotification('Error adding product', 'error');
    } finally {
      if (button) button.disabled = false;
      if (text) text.hidden = false;
      if (loader) loader.hidden = true;
    }
  }

  // Add multiple items (used by ComboPackManager)
  async addMultipleToCart(items, button = null) {
    const text = button?.querySelector('.btn-text');
    const loader = button?.querySelector('.btn-loader');

    if (button) button.disabled = true;
    if (text) text.hidden = true;
    if (loader) loader.hidden = false;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (response.ok) {
        await this.refreshCart();
        this.openCart();
        return true;
      } else {
        const error = await response.json();
        this.showNotification(error.description || 'Error adding bundle', 'error');
        return false;
      }
    } catch (error) {
      console.error('Error:', error);
      this.showNotification('Error adding bundle', 'error');
      return false;
    } finally {
      if (button) button.disabled = false;
      if (text) text.hidden = false;
      if (loader) loader.hidden = true;
    }
  }

  async updateQuantity(lineKey, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity
        })
      });

      if (response.ok) {
        await this.refreshCart();
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }

  async updateNote(note) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note })
      });
    } catch (error) {
      console.error('Error:', error);
    }
  }

  async refreshCart() {
    try {
      const response = await fetch('/?section_id=menu-cart-content');
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newItems = doc.querySelector('[data-cart-items]');
      const currentItems = document.querySelector('[data-cart-items]');
      if (newItems && currentItems) {
        currentItems.innerHTML = newItems.innerHTML;
      }

      const newFooter = doc.querySelector('[data-cart-footer]');
      const currentFooter = document.querySelector('[data-cart-footer]');
      if (newFooter && currentFooter) {
        currentFooter.innerHTML = newFooter.innerHTML;
        currentFooter.hidden = newFooter.hidden;
      }

      const newShipping = doc.querySelector('[data-shipping-progress]');
      const currentShipping = document.querySelector('[data-shipping-progress]');
      if (newShipping && currentShipping) {
        currentShipping.innerHTML = newShipping.innerHTML;
      }

      const cart = await fetch('/cart.js').then(r => r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        if (cart.item_count > 0) {
          el.textContent = cart.item_count;
          el.classList.remove('is-hidden');
        } else {
          el.textContent = '';
          el.classList.add('is-hidden');
        }
      });

    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
  }

  openCart() {
    const cartTab = document.querySelector('.cart-button');
    if (cartTab) {
      cartTab.click();
    }
  }

  showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#000' : '#ef4444'};
      color: white;
      padding: 1rem 1.5rem;
      border-radius: 0.5rem;
      z-index: 9999;
    `;
    document.body.appendChild(notification);
    setTimeout(() => notification.remove(), 3000);
  }
}

// ============================================
// COMBO PACK MANAGER
// ============================================
class ComboPackManager {
  constructor(cartAjax) {
    this.cartAjax = cartAjax;
    this.wrapper = document.querySelector('[data-combo-pack]');
    if (!this.wrapper) return;

    this.productId = this.wrapper.dataset.mainProduct;
    this.sectionId = this.wrapper.dataset.section;
    this.maxItems = parseInt(this.wrapper.dataset.maxItems) || 4;
    this.collectionHandle = this.wrapper.dataset.sourceCollection;
    
    this.grid = this.wrapper.querySelector('[data-combo-grid]');
    this.suggestionsContainer = this.wrapper.querySelector('[data-combo-suggestions]');
    this.totalElement = this.wrapper.querySelector('[data-combo-total]');
    this.submitButton = this.wrapper.querySelector('[data-combo-submit]');
    this.alertElement = this.wrapper.querySelector('[data-combo-alert]');
    
    this.selectedItems = new Map();
    
    this.init();
  }

  async init() {
    await this.loadRecommendations();
    this.attachEventListeners();
    this.initializeSelection();
    this.updateTotal();
    this.wrapper.hidden = false;
  }

  initializeSelection() {
    // Suggestion cards render checked by default, but selectedItems is only
    // populated on a change event. Single-variant products (e.g. the necklace,
    // which has no size picker) never fire one, so they'd stay checked yet be
    // excluded from the total and from "Add All to Cart". Add every checked
    // card whose variant is unambiguous (no size picker) up front. Multi-variant
    // products still require the shopper to pick a size before they count.
    this.wrapper
      .querySelectorAll('[data-combo-card]:not(.combo-card--anchor)')
      .forEach(card => {
        const checkbox = card.querySelector('[data-combo-checkbox]');
        const hasPicker = !!card.querySelector('[data-option-picker]');
        if (checkbox && checkbox.checked && !hasPicker) {
          this.addItemToSelection(card);
        }
      });
  }

  async loadRecommendations() {
    try {
      const url = this.collectionHandle
        ? `/collections/${this.collectionHandle}/products.json?limit=${this.maxItems}`
        : `/recommendations/products.json?product_id=${this.productId}&limit=${this.maxItems}`;
      
      const response = await fetch(url);
      const data = await response.json();
      const products = data.products || [];
      
      // Filtrar producto actual
      const recommendations = products.filter(p => p.id.toString() !== this.productId);
      
      this.renderRecommendations(recommendations.slice(0, this.maxItems - 1));
    } catch (error) {
      console.error('Error loading recommendations:', error);
      this.suggestionsContainer.innerHTML = '<span class="combo-error">Unable to load recommendations</span>';
    }
  }

  renderRecommendations(products) {
    if (!products.length) {
      this.suggestionsContainer.innerHTML = '<span class="combo-empty">No recommendations available</span>';
      return;
    }

    const html = products.map(product => {
      const firstVariant = product.variants[0];
      const hasMultipleVariants = product.variants.length > 1;
      
      return `
        <div
          class="combo-card"
          data-combo-card
          data-item-product="${product.id}"
          data-item-variant="${firstVariant.id}"
          data-item-price="${(firstVariant.price / 100).toFixed(2)}"
          data-item-stock="${firstVariant.available}"
          data-item-selected="true"
        >
          <input type="checkbox" checked class="combo-toggle" data-combo-checkbox>
          
          <div class="combo-card-media">
            <img 
              src="${this.getImageUrl(product.featured_image)}" 
              alt="${product.title}"
              loading="lazy"
            >
          </div>
          
          <div class="combo-card-details">
            <span class="combo-card-name">${this.truncate(product.title, 30)}</span>
            
            ${hasMultipleVariants ? `
              <select class="combo-option-picker" data-option-picker data-picker-product="${product.id}">
                <option value="" disabled selected>Select size</option>
                ${product.variants.map(variant => `
                  <option 
                    value="${variant.id}"
                    data-option-price="${(variant.price / 100).toFixed(2)}"
                    data-option-stock="${variant.available}"
                    ${!variant.available ? 'disabled' : ''}
                  >
                    ${variant.title} - ${this.formatMoney(variant.price)}
                    ${!variant.available ? ' (Out of stock)' : ''}
                  </option>
                `).join('')}
              </select>
            ` : `
              <span class="combo-card-amount">${this.formatMoney(firstVariant.price)}</span>
              ${!firstVariant.available ? '<span class="combo-stock-badge combo-stock-badge--unavailable">Out of stock</span>' : ''}
            `}
          </div>
        </div>
        <span class="combo-separator">+</span>
      `;
    }).join('');

    this.suggestionsContainer.innerHTML = html;
  }

  attachEventListeners() {
    // Checkbox toggles
    this.wrapper.addEventListener('change', (e) => {
      if (e.target.matches('[data-combo-checkbox]')) {
        this.handleCheckboxChange(e.target);
      }
    });

    // Variant selectors
    this.wrapper.addEventListener('change', (e) => {
      if (e.target.matches('[data-option-picker]')) {
        this.handleVariantChange(e.target);
      }
    });

    // Add to cart button
    this.submitButton.addEventListener('click', () => {
      this.addToCart();
    });
  }

  handleCheckboxChange(checkbox) {
    const card = checkbox.closest('[data-combo-card]');
    const isChecked = checkbox.checked;
    
    card.dataset.itemSelected = isChecked;
    
    if (isChecked) {
      this.addItemToSelection(card);
    } else {
      this.removeItemFromSelection(card);
    }
    
    this.updateTotal();
    this.updateSubmitButton();
  }

  handleVariantChange(select) {
    const option = select.options[select.selectedIndex];
    const card = select.closest('[data-combo-card]');
    
    card.dataset.itemVariant = option.value;
    card.dataset.itemPrice = option.dataset.optionPrice;
    card.dataset.itemStock = option.dataset.optionStock;
    
    if (card.dataset.itemSelected === 'true') {
      this.addItemToSelection(card);
      this.updateTotal();
      this.updateSubmitButton();
    }
  }

  addItemToSelection(card) {
    const productId = card.dataset.itemProduct;
    const variantId = card.dataset.itemVariant;
    const price = parseFloat(card.dataset.itemPrice);
    const available = card.dataset.itemStock === 'true';
    
    this.selectedItems.set(productId, {
      variantId,
      price,
      available
    });
  }

  removeItemFromSelection(card) {
    const productId = card.dataset.itemProduct;
    this.selectedItems.delete(productId);
  }

  updateTotal() {
    // Siempre incluir producto principal
    const mainCard = this.wrapper.querySelector('.combo-card--anchor');
    if (mainCard) {
      this.addItemToSelection(mainCard);
    }
    
    let total = 0;
    this.selectedItems.forEach(item => {
      total += item.price;
    });
    
    this.totalElement.textContent = this.formatMoney(total * 100);
  }

  updateSubmitButton() {
    const hasUnavailableItems = Array.from(this.selectedItems.values()).some(item => !item.available);
    const hasSelectedItems = this.selectedItems.size > 1; // More than just the main product
    
    this.submitButton.disabled = !hasSelectedItems || hasUnavailableItems;
  }

  async addToCart() {
    this.hideAlert();
    
    const items = Array.from(this.selectedItems.values()).map(item => ({
      id: item.variantId,
      quantity: 1
    }));
    
    // Use CartAjax to add multiple items
    const success = await this.cartAjax.addMultipleToCart(items, this.submitButton);
    
    if (!success) {
      this.showAlert('Unable to add bundle to cart. Please try again.');
    }
  }

  showAlert(message) {
    this.alertElement.textContent = message;
    this.alertElement.style.display = 'block';
  }

  hideAlert() {
    this.alertElement.style.display = 'none';
  }

  getImageUrl(imageUrl) {
    if (!imageUrl) return '';
    return imageUrl.replace('.jpg', '_100x.jpg').replace('.png', '_100x.png');
  }

  formatMoney(cents) {
    try {
      const code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(cents / 100);
    } catch (e) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  }

  truncate(str, length) {
    return str.length > length ? str.substring(0, length) + '...' : str;
  }
}

// ============================================
// INICIALIZACIÓN
// ============================================
class AppManager {
  constructor() {
    this.cartAjax = new CartAjax();
    this.initComboPack();
    this.observeComboPackChanges();
  }

  initComboPack() {
    // Destruir instancia anterior si existe
    if (this.comboPackManager) {
      this.comboPackManager = null;
    }
    
    // Crear nueva instancia si existe el wrapper
    if (document.querySelector('[data-combo-pack]')) {
      this.comboPackManager = new ComboPackManager(this.cartAjax);
    }
  }

  observeComboPackChanges() {
    // Watch DOM changes to detect SPA navigation
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.querySelector('[data-combo-pack]')) {
              this.initComboPack();
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also listen for navigation events
    window.addEventListener('popstate', () => {
      setTimeout(() => this.initComboPack(), 100);
    });

    // Si usas Shopify sections rendering
    document.addEventListener('shopify:section:load', () => {
      this.initComboPack();
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AppManager();
  });
} else {
  new AppManager();
}

